'use client';

import { AuthCustomerService } from '@/layers/application/services/auth/customer/auth-customer.service';
import { CpfCnpj } from '@/layers/domain/value-objects/profile/cpf-cnpj.vo';
import { confirmPasswordSchema } from '@/shared/application/validation/schemas/auth/confirm-password.schema';
import { passwordSchema } from '@/shared/application/validation/schemas/auth/password.schema';
import { cpfCnpjSchema } from '@/shared/application/validation/schemas/profile/cpf-cnpj.schema';
import {
  InputConfirmPassword,
  InputPassword,
} from '@/shared/components/features/auth/inputs/auth-inputs.components';
import { CustomerFirstAccessDto } from '@/shared/components/forms/auth/customer/dtos/customer-first-access.dto';
import { Button } from '@/shared/components/ui/button/button.component';
import { VerticalForm } from '@/shared/components/ui/form/vertical-form/vertical-form.component';
import { Input } from '@/shared/components/ui/input/input.component';
import { yupResolver } from '@hookform/resolvers/yup';
import { useRouter } from 'next/navigation';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useHookFormMask } from 'use-mask-input';
import { object } from 'yup';

export const CustomerFirstAccessForm: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<CustomerFirstAccessDto>({
    // @ts-ignore
    resolver: yupResolver(
      object({
        cpfCnpj: cpfCnpjSchema,
        // name: nameSchema,
        // email: emailSchema,
        // phoneNumber: wppAndPhoneSchema,
        password: passwordSchema,
        confirmPassword: confirmPasswordSchema(),
      }),
    ),
  });

  // const {
  //   register,
  //   formState: { errors, isSubmitting },
  // } = useForm();

  const registerWithMask = useHookFormMask(register);
  const router = useRouter();

  return (
    <VerticalForm
      id="form-first-access"
      // @ts-ignore
      onSubmit={handleSubmit(AuthCustomerService.firstAccess(router))}
      // onSubmit={(e) => {
      //   e.preventDefault();
      //   const id = TenantWebsite.getIdFromPathname(location.pathname);
      //   router.push(`/website/${id}/auth/customer/login`);
      // }}
    >
      <Input
        id="input-cpf-cnpj"
        label="CPF/CNPJ"
        hoverAnimations
        {...registerWithMask('cpfCnpj', CpfCnpj.masks())}
        error={
          errors.cpfCnpj?.message ? String(errors.cpfCnpj?.message) : undefined
        }
      />
      <InputPassword
        {...register('password')}
        error={
          errors.password?.message
            ? String(errors.password?.message)
            : undefined
        }
      />
      <InputConfirmPassword
        {...register('confirmPassword')}
        error={
          errors.confirmPassword?.message
            ? String(errors.confirmPassword?.message)
            : undefined
        }
      />
      <Button
        id="button-first-access"
        form="form-first-access"
        type="submit"
        disabled={isSubmitting}
        loading={{ state: isSubmitting, children: 'Cadastrando...' }}
      >
        Cadastrar-se
      </Button>
    </VerticalForm>
  );
};
